import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import { ServerCommunicationUtil } from './server_communication_util';
import { LanguageSupportUtil } from './language_support_util';
import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { PhotoSize } from '@alltrails/shared/types/photos';
import { getPhotoUrl } from '@alltrails/shared/utils/requests/photoRequests';

import {
  FILTER_ACCESS_STRINGS,
  FILTER_ACTIVITIES_STRINGS,
  FILTER_DIFFICULTIES_STRINGS,
  FILTER_FEATURE_TYPES_STRINGS,
  FILTER_LENGTHS_STRINGS,
  FILTER_OBSTACLES_STRINGS
} from './filters/filters.strings';

const getTrailProfilePhotoUrl = (trail, size = PhotoSize.Large) => {
  if (trail.profile_photo_url !== undefined) {
    // Note: in case that profile_photo_url is null, we simply want to assign a null value
    // rather than send requests to the API that would knowingly return as 404s
    return trail.profile_photo_url;
  }
  if (trail.profile_photo_data) {
    const [photoId, photoHash] = trail.profile_photo_data.split('-');
    return getPhotoUrl({ id: photoId, photoHash }, size);
  }
  return `/api/alltrails/trails/${trail.ID}/profile_photo?show_placeholder=no&size=${size}&key=${ServerCommunicationUtil.apiKey}`;
};

const getFormattedTrailUrls = (trail, languageRegionCode, prefix = null, suffix = null) => {
  // trail.slug has /trail already because its from algolia
  // If we dont have a slug for some reason go to explore
  let trailUrl;
  if (trail.slug) {
    trailUrl = trail.slug.includes('trail/') ? trail.slug : `/trail/${trail.slug}`;
    if (!trailUrl.startsWith('/')) {
      trailUrl = `/${trailUrl}`;
    }
    if (prefix) {
      if (!prefix.startsWith('/')) {
        prefix = `/${prefix}`;
      }
      trailUrl = `${prefix}${trailUrl}`;
    }
    if (suffix) {
      if (!suffix.startsWith('/')) {
        suffix = `/${suffix}`;
      }
      trailUrl = `${trailUrl}${suffix}`;
    }
  } else {
    trailUrl = `/explore`;
  }

  return {
    url: trailUrl,
    localizedUrl: LanguageSupportUtil.wrapUrlSafe(trailUrl, languageRegionCode)
  };
};

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const getAbbrevDescription = (trail, displayMetric) => {
  if (!displayMetric && trail.abbrev_desc_i) {
    return trail.abbrev_desc_i;
  }
  if (displayMetric && trail.abbrev_desc_m) {
    return trail.abbrev_desc_m;
  }

  return trail.description;
};

const getAllTags = () => {
  const { formattedDefaultMessages } = useFormatMessage({
    ...FILTER_ACCESS_STRINGS,
    ...FILTER_ACTIVITIES_STRINGS,
    ...FILTER_DIFFICULTIES_STRINGS,
    ...FILTER_FEATURE_TYPES_STRINGS,
    ...FILTER_LENGTHS_STRINGS,
    ...FILTER_OBSTACLES_STRINGS
  });

  return formattedDefaultMessages;
};

const stringConstantsKey = string => {
  return string.toUpperCase().replace(/(\s)|[-]/gi, '_');
};

const translateTag = (tag, localizedTags = getAllTags()) => {
  const tagKey = stringConstantsKey(tag);
  return localizedTags[tagKey] || tag;
};

const translateRouteType = routeType => {
  const routeKey = stringConstantsKey(routeType).replace('&', 'AND'); // for Out & Back
  return StringConstantsMixin.strings.FILTERS.ROUTE_TYPES[routeKey] || routeType;
};

export {
  getTrailProfilePhotoUrl,
  getFormattedTrailUrls,
  getAbbrevDescription,
  inIframe,
  translateTag,
  getAllTags,
  translateRouteType
};
